<template>
  <BubbleMenu
    :editor="editor"
    v-if="editor"
    :tippyOptions="{ maxWidth: 800 }"
    :shouldShow="
      ({ editor }) => {
        return editor.isActive('link');
      }
    "
  >
    <v-sheet
      style="position: relative; top: 0px"
      class="pa-3 rounded-xl"
      color="background"
    >
      <div class="arrow-down"></div>
      <v-container>
        <v-row align="center" justify="center">
          <v-col cols="auto" class="text-left">
            <v-sheet
              color="background"
              class="text-center py-2 px-3 rounded-lg"
            >
              <v-icon class="mt-n1" color="primary">mdi-link</v-icon>
              {{ $t("mainMenu.link") }}
            </v-sheet>
          </v-col>
          <v-col class="pt-2">
            <v-text-field
              style="margin-top: 3px; width: 200px"
              elevation="0"
              background-color="white"
              outlined
              dense
              hide-details
              v-model="href"
              :value="linkHref"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </BubbleMenu>
</template>

<script>
import { BubbleMenu } from "@tiptap/vue-2";

export default {
  props: {
    editor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      href: this.linkHref,
    };
  },
  components: {
    BubbleMenu,
  },
  computed: {
    linkHref() {
      if (this.editor && this.editor.getAttributes("link").href) {
        return this.editor.getAttributes("link").href;
      }
      return "";
    },
  },
  watch: {
    linkHref(href) {
      this.href = href;
    },
    href(href) {
      if (this.editor) {
        this.editor
          .chain()
          .extendMarkRange("link")
          .updateAttributes("link", {
            href: href,
          })
          .run();
      }
    },
  },
};
</script>
